(function () {
    'use strict';

    run.admin.parts.rackootClone = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const current_rackoot_item = document.getElementById('rackoot_nav_item__current');
        if (current_rackoot_item != null) {
            const item = document.getElementById('rackoot_nav_item__current');

            const rackoots_items__clone = document.getElementById('rackoots_items__clone');
            if (rackoots_items__clone) {
                rackoots_items__clone.addEventListener('click', function (e) {
                    rackootClone(item);
                });
            }
        }

        async function rackootClone(element) {
            const name_container = element.querySelectorAll('.rackoot__name')[0];
            const rackoot_name = name_container.innerHTML;
            Swal.fire({
                title: translations.rackoots.clone.messages.title,
                html: translations.rackoots.clone.messages.body1.replace('{rackoot_name}', rackoot_name),
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                focusCancel: true,
                cancelButtonText: translations.rackoots.clone.messages.buttonCancel,
                confirmButtonText: translations.rackoots.clone.messages.buttonConfirm,
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-lg btn-light',
                    confirmButton: 'btn btn-lg btn-primary ms-4'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            }).then((result) => {
                if (result.value) {
                    var data = new FormData();
                    data.append('csrf_name', csrf_name);
                    data.append('csrf_value', csrf_value);
                    data.append('rackoot_uuid', element.dataset.rackootUuid);

                    axios.post(GlobalRoutes.rackoots.clone, data)
                        .then(function (response) {
                            window.location = response.data.data.url;
                        })
                        .catch(function (error) {
                            new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                        });
                }
            });
        }
    }
})();
